import {Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ShippingsContextService} from '../../services/shippings-context.service';
import {Subscription} from 'rxjs';
import {ShippingsListComponent} from '../../../shipping/page/list/shippings-list.component';
import {ShippingDetailComponent} from '../../../shipping/page/detail/shipping-detail.component';
import {DataConfig} from '../../../shared/models/tabs-data';
import {ShippingDataService} from '../../../shipping/services/shipping-data.service';
import {ActivatedRoute} from '@angular/router';
import {replace} from '../../../shared';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../shared/reducers';

const components = {
  datatableShippingsList: ShippingsListComponent,
  shippingsEditable: ShippingDetailComponent
};

@Component({
  selector: 'storever-container-shippings',
  templateUrl: './container-shippings.component.html',
  styleUrls: ['./container-shippings.component.scss']
})
export class ContainerShippingsComponent implements OnInit, OnDestroy {

  componentRef;
  dataConfig: DataConfig;
  // @ViewChild('componentContainer', { read: ViewContainerRef }) container;
  @ViewChild('componentContainer',  {static: true , read: ViewContainerRef }) container;

  message: {context: string, clientId: string, siteId: string, shippingId: string};
  subscription: Subscription;

  constructor(private shippingsContextService: ShippingsContextService,
              private resolver: ComponentFactoryResolver,
              private shippingDataService: ShippingDataService,
              private activatedRoute: ActivatedRoute,
              private storeRoot: Store<fromRoot.AppState>) { }

  ngOnInit(): void {
    this.subscription = this.shippingsContextService.getContext().subscribe(message => {
      this.message = message;
      this.setDataConfig(message);
    });
    this.shippingsContextService.sendContext({context: 'Shippings', clientId: null, siteId: null, shippingId: null});
  }

  setDataConfig(data: {context: string, clientId: string, siteId: string, shippingId: string}): void {
    switch (data.context.toLowerCase()) {
      case 'Shippings'.toLowerCase():
        this.dataConfig = this.shippingDataService.getShippingsListData().dataTabs[0].dataConfig;
        this.createComponent('datatableShippingsList', data);
        break;
      case 'Shippings-add'.toLowerCase():
        this.createComponent('shippingsEditable', data);
        break;
      case 'Shippings-edit'.toLowerCase():
        this.createComponent('shippingsEditable', data);
        break;
    }
  }

  createComponent(content: string, data: {context: string, clientId: string, siteId: string, shippingId: string}): void {
    this.clearContainer();
    const component = components[content];
    const factory = this.resolver.resolveComponentFactory<ShippingDetailComponent | ShippingsListComponent>(component);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.dataConfig = this.dataConfig;

    const clientId = this.activatedRoute.snapshot.parent.paramMap.get('clientId');
    const siteId = this.activatedRoute.snapshot.paramMap.get('id');
    data.siteId = siteId;
    data.clientId = clientId;
    this.componentRef.instance.dataContext = data;
    this.storeRoot.dispatch(replace([], null, {fragment: 'Shippings'}));
  }

  clearContainer(): void {
    this.container.clear();
    if (this.componentRef) {
      if (this.componentRef.instance.sub$) {
        this.componentRef.instance.sub$.unsubscribe();
      }
      this.componentRef.destroy();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearContainer()
  }

}
